<template>
  <div class="sorteo">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Datos del Sorteo">
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="cliente"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="sorteoNombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="sorteoNombre"
                :value="sorteoNombre"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Sorteo"
              label-for="fechaSorteo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaSorteo"
                :value="fechaSorteo | fechaHora"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Resultados del Sorteo">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="participantes" 
                :fields="participantesFields" 
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              <template v-slot:cell(fechaNacimiento)="data">
                {{ data.item.fechaNacimiento | fecha }}
              </template>
              <template v-slot:cell(esCliente)="data">
                {{ data.item.esCliente? 'Si' : 'No' }}
              </template>
              <template v-slot:cell(staff)="data">
                {{ data.item.staff? 'Si' : 'No' }}
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              v-if="sorteoId != 0"
              @click.stop="exportParticipantes">
            <i class="fa fa-file-excel-o"></i>Exportar Resultados del Sorteo</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
// import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import exportXLSSorteo from '../../mixins/export_xls_sorteo';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'sorteo/getField',
  mutationType: 'sorteo/updateField',
});

export default {
  name: 'Sorteo',
  components: {
    // appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
    exportXLSSorteo 
  ],
  data: () => {
    return {
      eventoId: 0,
      sorteoGlobalId: 0,

      participantesFields: [
        { 
          key: 'posicion',
        }
      ],

      tableBusy: false,
      labelCols: 2,
      labelColsOpciones: 0
    }
  },
  computed: {
    ...mapFields([
      'sorteoId',
      'cliente',
      'sorteoNombre',
      'fechaSorteo',
      'participantes',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'nombre',

      'soloClientes',
      'dobleChanceClientes',

      'tipoEventoId'
    ]),
  },
  created() {
    if (this.$route.params){
      if (this.$route.params.eventoId){
        this.eventoId = this.$route.params.eventoId;
      }
      if (this.$route.params.sorteoGlobalId){
        this.sorteoGlobalId = this.$route.params.sorteoGlobalId;
      }
    }
    let params = {
      eventoId: this.eventoId,
      sorteoGlobalId: this.sorteoGlobalId
    }

    this.showSpinner();
    this.$store.dispatch('sorteo/inicializar', params)
      .then(() => {
        this.formatoGrilla();
        this.getItems();
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    formatoGrilla() {
      switch (this.tipoEventoId) {
        case 3: /* Whapp*/
          this.participantesFields = [
            { 
              key: 'posicion',
            },
            { 
              key: 'nombreCompleto',
              label: 'Nombre'
            },
            { 
              key: 'documentoNumero',
              label: 'Nro.Documento'
            },
            { 
              key: 'fechaNacimiento',
              label: 'Fecha Nacim.'
            },
            { 
              key: 'numeroCelular',
              label: 'Nro.Celular'
            },
            { 
              key: 'email' 
            },
          ];
          break;

        default:
          this.participantesFields = [
            { 
              key: 'posicion',
            },
            { 
              key: 'nombreCompleto',
              label: 'Nombre'
            },
            { 
              key: 'documentoNumero',
              label: 'Nro.Documento'
            },
            { 
              key: 'fechaNacimiento',
              label: 'Fecha Nacim.'
            },
            { 
              key: 'numeroCelular',
              label: 'Nro.Celular'
            },
            { 
              key: 'email' 
            },
            { 
              key: 'esCliente',
              label: 'Cliente',
              class: 'text-center'
            },
            { 
              key: 'numeroCliente',
              label: 'Nro.Cliente'
            },
          ];
        break;
      }
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('sorteo/getParticipantes')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    editarItem (item) {
      // this.$router.push({ name: 'ParticipanteABM', 
      //                     params: { id: item.id }});
    },
    consultar (item) {
      // this.$router.push({ name: 'ParticipanteDatos', 
      //                     params: { id: item.id }});
    },
    goBack() {
      this.$router.go(-1);
    },
    exportParticipantes() {
      this.showSpinner();
      this.$store.dispatch('sorteo/getParticipantesList')
        .then(() => {
          let exportar = false;
          let participantes = this.$store.getters['sorteo/participantesList'];

          if (participantes) {
            if (participantes.length != 0) {
              exportar = true;
            }
          }

          if (exportar) {
            this.exportXLSResultadosSorteo(this.eventoId, this.sorteoGlobalId, participantes);
          } else {
            this.showErrorMsj('Se produjo un error al recuperar la información de los participantes.');
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .sorteo .registro table td[aria-colindex="1"] {
    width: 5%;
  }
  .sorteo .registro table td[aria-colindex="2"] {
    width: 30%;
  }
  .sorteo .registro table td[aria-colindex="3"] {
    width: 10%;
  }
  .sorteo .registro table td[aria-colindex="4"] {
    width: 10%;
  }
  .sorteo .registro table td[aria-colindex="5"] {
    width: 10%;
  }
  .sorteo .registro table td[aria-colindex="6"] {
    width: 25%;
  }
  .sorteo .registro table td[aria-colindex="7"] {
    width: 5%;
  }
  .sorteo .registro table td[aria-colindex="8"] {
    width: 5%;
  }
</style>
